import { render, staticRenderFns } from "./EvergreenPhoneHome.vue?vue&type=template&id=763db501&"
import script from "./EvergreenPhoneHome.vue?vue&type=script&lang=js&"
export * from "./EvergreenPhoneHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports